module.exports = __webpack_public_path__ + "static/video-plyr-cover-23b7cab2ea07d0b5e6748ef8d637a5d5.jpg";